module.exports = __webpack_public_path__ + "media/images/pic/courses/intensity-intensive-4c2fadc4e4a0c1eba8c83bd19e80388d.svg";